import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BankPaymentPage } from './bank-payment.page';

const routes: Routes = [
  {
    path: '',
    component: BankPaymentPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class BankPaymentPageRoutingModule {}
